import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { environment } from 'environments/environment';
import { MenuSections } from '@app/interfaces/menu.interface';
import { Service as LayoutService } from '@services/layout.service';
import { Service as AlertService } from '@app/services/alert.service';
import { Service as ServiceStorage } from '@services/storage.service';
import { Service as AppSettingsService } from '@app/services/app_settings.service';
@Component({
    standalone: true,
    selector: 'app-sidebar',
    styleUrl: './sidebar.scss',
    templateUrl: './sidebar.html',
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, TranslatePipe, RouterModule],
})
export class Sidebar {
    private Translation: any = {};
    public api = environment.api;
    public project_name = environment.project_name;
    public project_version = environment.project_version;
    public admin_version = '0.0.0';
    public is_mini = false;
    public user_role = '';
    public current_role = '';
    public collapse: Record<string, boolean> = {};
    public MenuSections = MenuSections;

    constructor(
        private AlertService: AlertService,
        private TranslateService: TranslateService,
        private AppSettingsService: AppSettingsService,
        private ServiceStorage: ServiceStorage,
        private LayoutService: LayoutService,
    ) {
        this.MenuSections.filter(section => section.items).forEach(section => {
            this.collapse[section.id] = false;
        });
    }

    async ngOnInit() {
        this.Translation = await firstValueFrom(this.TranslateService.get(['SUCCESS', 'ERRORS', 'BUTTONS', 'LIST', 'MENU']));
        this.LayoutService.miniSidenav$.subscribe(state => {
            this.is_mini = state;
        });

        this.current_role = await this.ServiceStorage.get('role');
        this.user_role = await this.ServiceStorage.get('user_role');
        this.loadDataAppSettings();
    }

    toggle(id: string): void {
        this.collapse[id] = !this.collapse[id];
    }
    
    isVisible(visible?: boolean): boolean {
        return visible !== false;
    }

    canShow(element: { roles?: string[]; visible?: boolean }): boolean {
        return this.hasPermission(element.roles) && this.isVisible(element.visible);
    }

    hasPermission(roles?: string[]): boolean {
        if (!roles || roles.length === 0) return true;
        // console.log(this.current_role);
        return roles.includes(this.current_role);
    }

    async loadDataAppSettings() {
        const return_data = await this.AppSettingsService.getList({ active: 1, deleted: 1 });
        // console.log(return_data);

        if (return_data.success == 1) {
            if (return_data.data != undefined && return_data.data.length > 0) {
                const admin_version = return_data.data.find((row: any) => row.name === 'admin_version');

                if (admin_version) {
                    this.admin_version = admin_version.value;
                }
            }
        } else {
            console.log(return_data);
            this.AlertService.alert({ title: return_data.error, text: return_data.reason, timer: 5000 });
        }
    }
}